import { Directive } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CriteriaObj } from '@src/suite/common/data-models/criteria/criteria-obj';

import { ADORNER_IDS } from '../enums/constants';
import { isValidUrl } from '../utils/util';
import { AbstractAdornerDirective } from './abstract-adorner';

@Directive({ selector: '[st-topic-icon]' })
export class TopicIconDirective extends AbstractAdornerDirective {
    protected get locationID(): string {
        return ADORNER_IDS.TopicIcon;
    }
    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj; adorner: Adorner }) {
        // this.renderer.addClass(this.el.nativeElement, "topic-circle");
        this.renderer.addClass(this.el.nativeElement, 'topic-round-icon');
        this.renderer.addClass(this.el.nativeElement, 'left');

        const iconUrlIsPotentiallyMatIcon = vcToApply?.adorner?.IconUrl && !isValidUrl(vcToApply?.adorner?.IconUrl);
        if (vcToApply?.adorner) {
            if (vcToApply.adorner.Icon || iconUrlIsPotentiallyMatIcon) {
                const icon = vcToApply.adorner.Icon || vcToApply.adorner.IconUrl;
                this.renderer.addClass(this.el.nativeElement, icon);
                if (vcToApply.adorner.Color) {
                    this.renderer.setStyle(this.el.nativeElement, 'color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, '-webkit-text-fill-color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, 'font-size', '1.2em');
                }

                if (this.lastMatIconEl) {
                    this.renderer.removeChild(this.el.nativeElement, this.lastMatIconEl.location.nativeElement);
                    this.lastMatIconEl.destroy();
                    this.lastMatIconEl = null;
                }
                this.lastMatIconEl = this.viewContainerRef.createComponent(MatIcon);
                this.renderer.addClass(this.lastMatIconEl.location.nativeElement, 'st-icon-content');
                const matIconText = this.renderer.createText(icon);
                this.renderer.appendChild(this.lastMatIconEl.location.nativeElement, matIconText);

                this.renderer.appendChild(this.el.nativeElement, this.lastMatIconEl.location.nativeElement);
            } else if (vcToApply.adorner.IconUrl) {
                this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${vcToApply.adorner.IconUrl})`);
                this.renderer.setStyle(this.el.nativeElement, 'background-size', 'contain');
                if (vcToApply.adorner.Color) {
                    this.renderer.setStyle(this.el.nativeElement, 'color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, '-webkit-text-fill-color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, 'font-size', '1.2em');
                }
            } else if (vcToApply.adorner.Color) {
                this.renderer.setStyle(this.el.nativeElement, 'background-color', vcToApply.adorner.Color);
            } else {
                // default
                this.renderer.setStyle(this.el.nativeElement, 'background-color', '#DBDBDB');
            }
        } else {
            this.renderer.setStyle(this.el.nativeElement, 'background-color', '#DBDBDB');
        }
    }
}
